import { createFileRoute } from '@tanstack/react-router';
import { CommunityFeedPage } from '../components/community/CommunityFeedPage';

export const Route = createFileRoute('/community/feed')({
  component: CommunityFeedPage,
});
